const TermsAndCondition = () => {
    
const termsData = [
  {
    title: "Acceptance of Terms",
    description: "By accessing or using the Tenafix platform, you (\"User\", \"Landlord\", \"Tenant\", or \"Customer\") agree to these Terms & Conditions. If you do not agree, please do not use our services."
  },
  {
    title: "Scope of Services",
    description: "Tenafix provides:\nA digital platform for rent collection and property management.\nSecure rent payment processing through our payment gateway partner (currently Relworx).\nAutomatic payouts to landlords, net of applicable fees.\nOptional premium services, such as legal, tax, and maintenance support, which may be requested on demand."
  },
  {
    title: "Fees and Charges",
    description: "Tenafix charges service fees for the use of its platform, including software access, transaction processing, and management services.\nPayment gateway providers and mobile money operators may also charge their own fees.\nThe applicable fees and charges are displayed on the Tenafix platform and may change from time to time.\nBy using the service, users agree to the fees in effect at the time of the transaction."
  },
  {
    title: "Landlord Responsibilities",
    description: "Provide accurate property and tenant information.\nEnsure compliance with Ugandan rental, tax, and financial laws.\nMaintain tenant relationships unless Tenafix is formally engaged for full management."
  },
  {
    title: "Tenant Responsibilities",
    description: "Make timely rent payments using the unique payment code provided.\nEnsure sufficient funds are available at the time of payment.\nRetain receipts for record-keeping."
  },
  {
    title: "Refunds & Disputes",
    description: "Payments are final and non-refundable, except in cases of duplicate or erroneous transactions.\nDisputes between landlords and tenants remain the responsibility of the parties unless Tenafix is formally contracted for management services."
  },
  {
    title: "Limitation of Liability",
    description: "Tenafix is not responsible for:\nNetwork outages, gateway downtime, or third-party system failures.\nTenant default or landlord mismanagement.\nErrors resulting from inaccurate or incomplete user information.\nOur maximum liability shall not exceed the service fees paid for the disputed transaction."
  },
  {
    title: "Amendments",
    description: "Tenafix may amend these Terms from time to time. Users will be notified of material changes via the platform or email. Continued use of the service after notice constitutes acceptance of the updated Terms."
  }
];

  return (
    <div className="px-4 md:px-8 lg:px-[120px]">
      <div className="h-20 md:h-32 lg:h-[136px] bg-[#F6F5FF] flex justify-center items-center">
        <h1 className="mt-0 font-semibold font-Alexandria text-2xl md:text-4xl lg:text-[46px] text-center text-[#071952]">
          Terms & Conditions
        </h1>
      </div>

      <div className="px-4 md:px-6 lg:px-[24px] mt-8 md:mt-12 lg:mt-[52px] pb-4 md:pb-6 lg:pb-[20px] space-y-3 md:space-y-4 lg:space-y-[15px]">
        <div>
          <p className="font-poppins text-sm md:text-[15px] text-[#494949]">
            Effective Date: 2025-09-25
          </p>
          <p className="font-poppins text-sm md:text-[15px] text-[#494949]">
            Company: Tenafix Limited ("Tenafix", "we", "our", "us")
          </p>
        </div>
      </div>

      <div className="px-4 md:px-6 lg:px-[24px] mb-16 md:mb-24 lg:mb-[120px]">
        {termsData.map((term, index) => (
          <div key={index} className="mt-6 md:mt-8 lg:mt-[24px]">
            <h2 className="font-poppins mb-4 md:mb-5 lg:mb-[20px] text-lg font-semibold">{term.title}</h2>
            {term.description.split('\n').map((paragraph, pIndex) => (
              <p key={pIndex} className="font-poppins text-sm md:text-[15px] text-[#494949]">
                {paragraph}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TermsAndCondition;